const Emoji = [
    {
        name: "Rock",
        emoji: "✊",
        short_name: "R"
    },
    {
        name: "Paper",
        emoji: "📄",
        short_name: "P"
    },
    {
        name: "Scissor",
        emoji: "✂️",
        short_name: "S"
    },
    {
        name: "Lizard",
        emoji: "🦎",
        short_name: "L"
    },
    {
        name: "Spock",
        emoji: "🖖",
        short_name: "K"
    }
];

export default Emoji;
